

/**
 * General_init.js
 */


class General_init {

    constructor() {}; 

    static init() {


        General_init.funcWindowSize();
        //  ウインドウのサイズが変更されたときの処理登録
        window.addEventListener("resize", General_init.funcWindowSize, false);

        //  画面スクロールイベント登録
        window.onscroll = function(){
    
            // skipBt
            var offsetY = window.pageYOffset;
            if(offsetY>300) {
                document.getElementById('skipDiv').style['display'] = 'block';
            }else {
                document.getElementById('skipDiv').style['display'] = 'none';	
            };

        };
    
	    MyUtility.setElementEvent( 'skipTop', 'click', General_init.skipeTop, false );
        MyUtility.setElementEvent( 'skipBottom', 'click', function() { return General_init.skipeBottom('footerTop')}, false );
    
        //  コンテンツボタン
        let objList = [ { idString: 'cont-pull-ul-1', is: false }, { idString: 'cont-pull-ul-2', is: false },
                        { idString: 'cont-pull-ul-3', is: false }, { idString: 'cont-pull-ul-4', is: false } ];
        for(var i=0; i<4; i++) {
            if(document.getElementById('cont-label-down-'+(i+1))) {
                MyUtility.setElementEvent('cont-label-down-'+(i+1), 'click', MyUtility.buttonDownBoxProcess( objList, i), false);
            };
        };

        // コンテンツボタン  モバイル用
        for(var i=0; i<4; i++) {
            if(document.getElementById('cont-pull-ul-'+(i+1)+'-mov')) {
                MyUtility.setElementStyle('cont-pull-ul-'+(i+1)+'-mov', 'display', 'none');
            };
        };
        let objList_mov = [ { idString: 'cont-pull-ul-1-mov', is: false }, { idString: 'cont-pull-ul-2-mov', is: false },
                        { idString: 'cont-pull-ul-3-mov', is: false }, { idString: 'cont-pull-ul-4-mov', is: false } ];
        for(var i=0; i<4; i++) {
            if(document.getElementById('cont-label-down-'+(i+1)+'-mov')) {
                MyUtility.setElementEvent('cont-label-down-'+(i+1)+'-mov', 'click', MyUtility.buttonDownBoxProcess( objList_mov, i), false);
            };
        };

    };

    static funcWindowSize() {

        var width = window.innerWidth;
        //  skipBt
        if(width > 1200) {
            document.getElementById("skipDiv").style.right = (width-1100)/2-60+'px';
        }else if(width>500){
            document.getElementById("skipDiv").style.right = "20px";
        }else {
            document.getElementById("skipDiv").style.right = "10px";
            document.getElementById("skipDiv").style.bottom = "8px";
        };
    };



    static skipeTop() {

        var offsetY = window.pageYOffset;

        var range = offsetY > 2000 ? offsetY/20 :  100;

        var timer = window.setInterval( function() { return General_init.windowScroll( timer, true, range, 0) }, 12 );

        //  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
        var timer2 = window.setTimeout( function() { return window.clearInterval( timer ) }, 500);

    };

    static skipeBottom( idStr ) {

        var offsetY = window.pageYOffset;
        var windowH = window.innerHeight;

        var targetTop = offsetY+document.getElementById(idStr).getBoundingClientRect().top;

        var range = targetTop-offsetY > 2000 ? (targetTop-offsetY)/20 : 100;

        var end = idStr==='footerTop' ? targetTop-windowH : targetTop-5;

        var timer = window.setInterval( function() { return General_init.windowScroll( timer, false, range, end ) }, 12 );

        //  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
        var timer2 = window.setTimeout( function() { return window.clearInterval( timer ) }, 500);

    };


    static windowScroll( timer, isUpDown, range, end) {

        var offsetY = window.pageYOffset;

        if(isUpDown) {
            if(end>=offsetY) {
                window.clearInterval( timer );
            }else {
                offsetY = offsetY-range < end ? end : offsetY-range;
                window.scroll(0, offsetY);
            };
        }else {
            if(end-20<=offsetY) {
                window.clearInterval(timer);
            }else {
                offsetY = offsetY+range > end ? end : offsetY+range;
                window.scroll(0, offsetY);
            };
        };
    };

};


function setState34(val) {

    var isStorage = !!sessionStorage;

    if(isStorage) {

        var statelocalObj = StorageOperator.getStorageData('local', 'state');
        if(statelocalObj) {
			statelocalObj.or34 = val;
		}else {
			statelocalObj = { or34: val };
		};

        var stateObj = StorageOperator.makePageStateJson( val );

        var boo = [false, false], boo2 = [false, false];
        try {
            boo = StorageOperator.setStorageData( 'session', 'state', stateObj );
            boo2 = StorageOperator.setStorageData( 'local', 'state', statelocalObj );
    
        }catch(exeption) {
            //alert('お使いのブラウザでは、本サイトは正常に動作しません');
        };

        return boo[0] && boo2[0];
    };
    return false;
};




